import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  readonly isGo = environment.apiMode === 'go'
  readonly realtimeV3 = environment.realtimeMode === 'v3'
}
